var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessageBubbleTransparent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2222 17.2961L13.5758 16.9426L13.4293 16.7961H13.2222V17.2961ZM18.9257 22.9996L18.5722 23.3532L19.4257 24.2067V22.9996H18.9257ZM18.9257 17.2961V16.7961H18.4257V17.2961H18.9257ZM1.5 4C1.5 2.61929 2.61929 1.5 4 1.5V0.5C2.067 0.5 0.5 2.067 0.5 4H1.5ZM1.5 14.2961V4H0.5V14.2961H1.5ZM4 16.7961C2.61929 16.7961 1.5 15.6768 1.5 14.2961H0.5C0.5 16.2291 2.067 17.7961 4 17.7961V16.7961ZM13.2222 16.7961H4V17.7961H13.2222V16.7961ZM12.8687 17.6497L18.5722 23.3532L19.2793 22.6461L13.5758 16.9426L12.8687 17.6497ZM19.4257 22.9996V17.2961H18.4257V22.9996H19.4257ZM19.185 16.7961H18.9257V17.7961H19.185V16.7961ZM21.685 14.2961C21.685 15.6768 20.5657 16.7961 19.185 16.7961V17.7961C21.118 17.7961 22.685 16.2291 22.685 14.2961H21.685ZM21.685 4V14.2961H22.685V4H21.685ZM19.185 1.5C20.5657 1.5 21.685 2.61929 21.685 4H22.685C22.685 2.067 21.118 0.5 19.185 0.5V1.5ZM4 1.5H19.185V0.5H4V1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7H17M6 11H13.6154",
    stroke: "currentColor",
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageBubbleTransparent);
export default __webpack_public_path__ + "static/media/message-bubble-transparent.ec181ec4.svg";
export { ForwardRef as ReactComponent };